import styled from "styled-components";

export const Title = styled.div`
    font-family: 'Pixel Coleco';
    color: #fed230;
    font-size: 3vh;
    text-align: center;
    height: 10vh;
    width: 40vw;
    padding-left: 30vw;
    box-sizing: unset;
    display: table-cell;
    vertical-align: ${props => props.verticalAlign === 'top' ? 'top' : 'bottom'};
`;
